import { Box, Link, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import Banner from 'modules/payroll_bundle/components/Banner'

interface Props {
  count: number
  viewIssues: () => void
}

export const ResultValidationsBanner = ({ count, viewIssues }: Props) => {
  return (
    <Box paddingTop="s24" paddingX="s40">
      <Banner icon="validation">
        <Box justifyContent="spaceBetween" alignItems="center" flexDirection="row" width="full">
          <Text.Normal>
            {i18n.tp('payroll_bundle.results_payments.results.validations.banner_title', {
              count: count,
            })}
          </Text.Normal>
          <Link.Touchable onClick={viewIssues}>
            <Text.Normal weight="semibold" underlined>
              {i18n.t('payroll_bundle.results_payments.results.validations.review_link')}
            </Text.Normal>
          </Link.Touchable>
        </Box>
      </Banner>
    </Box>
  )
}
